import { captureMessage } from '@sentry/react';
import { envs } from '../../../envs';

const parseEnvVariable = (envVariable: string, errorMessage: string) => {
  try {
    return JSON.parse(envVariable);
  } catch (_) {
    // eslint-disable-next-line no-console
    console.error(errorMessage);
    captureMessage(errorMessage);
    return [];
  }
};

//TODO: Move it outside components doesnt make sense to be inside components
// Note:
// This file should contain constant values that are user throughout

// the application, lets not repeat ourselves
export const staticContent = envs.REACT_APP_COVALO_STATIC_CONTENT;
//temporary used for pictures
export const staticContentServices =
  envs.REACT_APP_UXBEAUTY === 'true'
    ? staticContent
    : staticContent?.replace('com', 'services');

export const baseApiSearch = envs.REACT_APP_COVALO_API_SEARCH;
export const STAGING_COMPANY_KEY = 'staging-for-covalo-scm';
export const baseApi = envs.REACT_APP_COVALO_API;
export const baseApiLegacy = envs.REACT_APP_COVALO_LEGACY_API;
export const mainColor = '#ff6b6b';
export const TOP_PRODUCT_MAXIMUM_LENGTH = 5;
export enum UserStateContextType {
  LOADING = 'LOADING',
  AUTHENTICATED = 'AUTHENTICATED',
  NOT_AUTHENTICATED = 'NOT_AUTHENTICATED'
}

export enum SupplierPortalUserStatus {
  NOT_SIGNED_UP = 'NOT_SIGNED_UP',
  AWAITING_VERIFICATION = 'AWAITING_VERIFICATION',
  VERIFIED = 'VERIFIED',
  BLOCKED = 'BLOCKED'
}

/**
 * @deprecated You should use the whitelabel event and company key instead!
 */
export const IS_UXBEAUTY = envs.REACT_APP_UXBEAUTY === 'true';

// TODO: to be renamed to CUSTOMER_PORTAL_KEY for better understanding
export const WHITELABEL_EVENT_KEY =
  envs.REACT_APP_COVALO_WHITELABEL_EVENT_KEY || undefined;
// TODO: to be renamed to CUSTOMER_PORTAL_COMPANY_KEY for better understanding
export const WHITELABEL_COMPANY_KEY =
  envs.REACT_APP_WHITELABEL_COMPANY_KEY || undefined;

export const WHITELABEL_IMAGE_PLACEHOLDER =
  staticContent + '/uxb/backgrounds/DEFAULT_IMAGE.webp';
export const UxBeautyTrendsAndScienceImage =
  staticContent + '/uxb/backgrounds/TrendsAndScience/background.jpg';

export const RECENTLY_LAUNCHED_FILTERS = [
  { year: '2025', active: false },
  { year: '2024', active: false },
  { year: '2023', active: false }
];

export const currentPlatform = IS_UXBEAUTY ? 'UX-Beauty' : 'Covalo';
// this covalo companies can be changed to a diferent structure if its relevant, just a starting point using an array
export const COVALO_COMPANIES = ['covalo', 'harmona'];

export const NAVBAR_ID = 'nav';
export const PRODUCT_EDITOR_HEADER_ID = 'productHeaderSection';
// Using the extracted function for INCOS_EVENTS
export const INCOS_EVENTS = (() => {
  if (IS_UXBEAUTY) return [];
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const jsonString = envs.REACT_APP_INCOS_EVENTS!;
  const errorMessage =
    'The INCOS_EVENTS environment variable is missing or contains an invalid JSON format. Please ensure it is a properly formatted JSON array with the correct event keys.';

  return parseEnvVariable(jsonString, errorMessage);
})();
export const columnConfiguration: {
  eventKey: string;
  fields: {
    id: string;
  }[];
}[] = (() => {
  if (IS_UXBEAUTY) return [];

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const jsonString = envs.REACT_APP_BRANDPORTAL_COLUMN_CONFIGURATIONS!;
  const errorMessage =
    'Bp Column configurations are missing or contains an invalid JSON format. Please ensure it is a properly formatted JSON array with the correct event keys.';

  return parseEnvVariable(jsonString, errorMessage);
})();

export const NOTIFICATIONS_REFRESH_INTERVAL = 120000; // slower update of the overall notifications of the website
export const NOTIFICATIONS_REFRESH_INTERVAL_ON_PAGE = 20000; // for when the user is on a page where is nicer to have faster refreshed information
// from BE: application.yaml -> servlet.multipart.max-file-size
export const UPLOAD_MAX_FILE_SIZE = 30 * 1024 * 1024;
// from BE: application.yaml -> servlet.multipart.max-request-size
export const UPLOAD_MAX_REQUEST_SIZE = 35 * 1024 * 1024;

export const createPageTitle = (title: string) =>
  `${IS_UXBEAUTY ? 'UX-Beauty' : 'Covalo'} | ${title}`;

export const DATE_FORMAT = 'DD/MM/YYYY';

export const SCROLLABLE_DIV_ID = 'scrollable-div';

export enum SEARCH_ZONES_KEYS {
  SUSTAINABILITY_ZONE = 'sustainability-zone',
  INNOVATION_ZONE = 'innovation-zone'
}
